"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTooltipContent = exports.StyledQuestionMark = exports.StyledTooltipWrapper = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const flexbox_1 = require("../flexbox");
const boxBGColor = theme_1.primary.darker;
exports.StyledTooltipWrapper = styled_components_1.default.div `
  [data-tippy-root] {
    max-width: calc(100vw - 10px);
  }

  .tippy-box {
    width: ${({ unsetWidth }) => (unsetWidth ? 'unset' : '270px')};
    word-break: ${({ unsetWidth }) => (unsetWidth ? 'break-all' : 'normal')};
    padding: ${theme_1.spacings.s4};
    position: relative;
    background-color: ${boxBGColor};
    color: ${theme_1.grayScale[50]};
    border-radius: 8px;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    outline: 0;
    transition-property: transform, visibility, opacity;
  }

  .tippy-box[data-inertia][data-state='visible'] {
    transition-timing-function: cubic-bezier(0.54, 1.5, 0.38, 1.11);
  }

  .tippy-content {
    position: relative;
    z-index: 1;
  }
  .tippy-box[data-placement^='top'] > .tippy-svg-arrow {
    bottom: 0;
  }

  .tippy-box[data-placement^='top'] > .tippy-svg-arrow:after,
  .tippy-box[data-placement^='top'] > .tippy-svg-arrow > svg {
    top: 2px;
    right: 7px;
    transform: rotate(180deg);
  }

  .tippy-box[data-placement^='bottom'] > .tippy-svg-arrow {
    top: 0;
  }

  .tippy-box[data-placement^='bottom'] > .tippy-svg-arrow > svg {
    bottom: 2px;
    right: 7px;
  }

  .tippy-box[data-placement^='left'] > .tippy-svg-arrow {
    right: 0;
  }

  .tippy-box[data-placement^='left'] > .tippy-svg-arrow:after,
  .tippy-box[data-placement^='left'] > .tippy-svg-arrow > svg {
    transform: rotate(90deg);
    top: calc(50% - 11px);
    left: 3px;
  }

  .tippy-box[data-placement^='right'] > .tippy-svg-arrow {
    left: 0;
  }

  .tippy-box[data-placement^='right'] > .tippy-svg-arrow:after,
  .tippy-box[data-placement^='right'] > .tippy-svg-arrow > svg {
    transform: rotate(-90deg);
    top: calc(50% - 11px);
    right: 3px;
  }

  .tippy-svg-arrow {
    width: 16px;
    height: 16px;
    fill: ${boxBGColor};
    text-align: initial;
  }

  .tippy-svg-arrow,
  .tippy-svg-arrow > svg {
    position: absolute;
  }

  .tippy-box {
    &[data-placement='top'],
    &[data-placement='bottom'] {
      & > .tippy-svg-arrow:after,
      & > .tippy-svg-arrow > svg {
        right: -3px;
      }
    }
    &[data-placement='top-start'] {
      transform: translateX(-10px);
      & > .tippy-svg-arrow:after,
      & > .tippy-svg-arrow > svg {
        left: 7px;
      }
    }
    &[data-placement='top-end'] {
      transform: translateX(15px);
      & > .tippy-svg-arrow:after,
      & > .tippy-svg-arrow > svg {
        right: 10px;
      }
    }
    &[data-placement='bottom-start'] {
      transform: translateX(-10px);
      & > .tippy-svg-arrow:after,
      & > .tippy-svg-arrow > svg {
        right: -14px;
      }
    }
    &[data-placement='bottom-end'] {
      transform: translateX(10px);
      & > .tippy-svg-arrow:after,
      & > .tippy-svg-arrow > svg {
        right: 6px;
      }
    }
    &[data-placement='right-start'] {
      transform: translateY(-13px);
      & > .tippy-svg-arrow:after,
      & > .tippy-svg-arrow > svg {
        top: 50%;
      }
    }
    &[data-placement='right-end'] {
      transform: translateY(10px);
      & > .tippy-svg-arrow:after,
      & > .tippy-svg-arrow > svg {
        top: calc(50% - 21px);
      }
    }
    &[data-placement='left-start'] {
      transform: translateY(-11px);
      & > .tippy-svg-arrow:after,
      & > .tippy-svg-arrow > svg {
        top: 50%;
      }
    }
    &[data-placement='left-end'] {
      transform: translateY(10px);
      & > .tippy-svg-arrow:after,
      & > .tippy-svg-arrow > svg {
        top: calc(50% - 21px);
      }
    }
  }
`;
exports.StyledQuestionMark = styled_components_1.default.div `
  display: flex;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;

  ${({ questionMarkColor, questionMarkColorHover }) => (0, styled_components_1.css) `
    svg[aria-label='QuestionRoundedIcon'] {
      circle,
      path {
        stroke: ${questionMarkColor};
      }
      rect {
        fill: ${questionMarkColor};
      }
    }

    &:hover {
      svg[aria-label='QuestionRoundedIcon'] {
        circle,
        path {
          stroke: ${questionMarkColorHover};
        }
        rect {
          fill: ${questionMarkColorHover};
        }
      }
    }
  `}

  &:focus-visible {
    box-shadow: ${theme_1.shadows.containedFocus(theme_1.primary.main, theme_1.primary.main)};
  }
`;
exports.StyledTooltipContent = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 8px;

  h6 {
    color: ${theme_1.grayScale[50]};
  }

  svg[aria-label='Export'] path {
    stroke: ${theme_1.grayScale[50]};
  }
  button {
    width: unset;
  }
`;
//# sourceMappingURL=styles.js.map